import { GET, POST, PUT, DELETE } from './api';

export const ReadHome = async () => {
  // Strapi 5 dropped v4 dot-notation populate and has no `icon` field on the
  // home single-type — the old query 400'd, blanking the hero banner. Use the
  // nested populate that resolves featured_show/featured_banner (mirrors mobile).
  return await GET(
    `/home?populate[featured][populate][featured_show][populate]=*&populate[featured][populate][featured_banner][populate]=*`,
  );
};

export const ReadHomeTabs = async () => {
  return await GET(`/tabs?populate[0]=icon`);
};

export const ReadTabPlaylist = async () => {
  return await GET(
    `/collections?populate[0]=stream_shows.thumbnail&populate[1]=stream_shows.categories&populate[2]=icon`,
  );
};

export const ReadTabCatalog = async (tabId: number | string) => {
  return await GET(
    `/collections?filters[tab]=${tabId}&populate[0]=stream_shows.thumbnail&populate[1]=stream_shows.categories&populate[2]=icon`,
  );
};

export const ReadCatalogDetails = async (catalogId: number | string) => {
  return await GET(
    `/collections/${catalogId}?populate[0]=stream_shows.thumbnail&populate[1]=stream_shows.categories&populate[2]=icon`,
  );
};

export const ReadCategories = async () => {
  return await GET(`/categories`);
};

export const ReadSearch = async (searchExpression: string) => {
  return await GET(
    `/stream-shows/?pagination[start]=1&[limit]=20&[populate][0]=thumbnail&[populate][1]=categories&filters[name][$containsi]=${searchExpression}`,
  );
};

export const ReadSearchByTheme = async (themeId: number | string) => {
  return await GET(
    `/stream-shows/?pagination[start]=1&[limit]=20&[populate][0]=thumbnail&[populate][1]=categories&filters[themes]=${themeId}`,
  );
};

export const ReadSearchByCharacter = async (charId: number | string) => {
  return await GET(
    `/stream-shows/?pagination[start]=1&[limit]=20&[populate][0]=thumbnail&[populate][1]=categories&filters[characters]=${charId}`,
  );
};

export const ReadKids = async () => {
  return await GET(
    `/collections?filters[name]=Kids&populate[0]=stream_shows.thumbnail&populate[1]=stream_shows.categories`,
  );
};

export const ReadProgressPlayer = async (
  streamId: number | string,
  profileId: number | string,
  token: string,
) => {
  return await GET(
    `/progress-players?filters[profile]=${profileId}&filters[stream_show]=${streamId}&sort[0]=id:desc`,
    token,
  );
};

export const CreateProgressPlayer = async (body: unknown, token: string) => {
  return await POST(`/progress-players`, body, token);
};

export const ReadKeepWatching = async (id: number | string, token: string) => {
  return await GET(
    `/progress-players?filters[profile]=${id}&populate[0]=stream_show.thumbnail&populate[1]=stream_show.categories&sort[0]=updatedAt:desc&sort[1]=createdAt:desc&pagination[pageSize]=1000`,
    token,
  );
};

export const UpdateProgressPlayer = async (id: number | string, body: unknown, token: string) => {
  return await PUT(`/progress-players/${id}`, body, token);
};

export const ReadShowDetails = async (showId: number | string, token: string) => {
  return await GET(
    `/stream-shows/${showId}?[populate][0]=thumbnail&[populate][1]=wide_picture&[populate][2]=related_shows.thumbnail&[populate][3]=stream_master_file&[populate][4]=mobile_download_mp4&[populate][5]=next_stream`,
    token,
  );
};

export const ReadPreviewsShow = async (showId: number | string, token: string) => {
  // v5 relation filter + pagination syntax (mirrors web catalog.ts fix).
  return await GET(
    `/stream-shows?filters[next_stream][documentId][$eq]=${showId}&pagination[limit]=1`,
    token,
  );
};

export const ReadSerchableCharacteres = async () => {
  return await GET(`/characters`);
};

export const ReadSerchableThemes = async () => {
  return await GET(`/themes`);
};
